export default __webpack_public_path__ + "static/media/shoe.a3d409c2.png";